export default __webpack_public_path__ + "static/media/plaguedheartcurse.d48d3907.png";